module.exports = __webpack_public_path__ + "img/reward.6ff114ab.svg";